import React from 'react';
import { TimelineItemBordered } from '../../';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const BorderedItem: React.FC<Props> = ({ item, isSimple, isExpanded }) => (
  <TimelineItemBordered
    item={item}
    isSimple={isSimple}
    isExpanded={isExpanded}
  />
);

export default BorderedItem;
